
import {Container,TextStyle, Text, Graphics} from 'pixi.js'
export default class ButtonSolid extends Container {
    constructor(text,color,width,style, ...arg) {
        super(...arg);
        this._text = text;
        this.color = color || 0x479ACE;// or 0x479ACE or 0xC03500;
        this.width1 = width||220;
        this.style = style;
        if (!this.style) {
            this.style = new TextStyle({
                fontFamily: 'Arial',
                fontSize: 34 * 2,
                fill: '#FFFFFF',
                align: 'center'
            });
        }

        //background
        var graphics = new Graphics();
        graphics.beginFill( this.color);
        graphics.lineStyle(0, 0xFFFFFF, 1);
        // graphics.drawRect(0, 0, 250, 60);
        graphics.drawRoundedRect(0, 0, this.width1, 60, 10);
        //graphics.alpha = 0.9;
        this.addChild(graphics);



        //this.width = 400;
        //this.height = 50;
        //this.anchor.set(0.5);


        this.textMessage = new Text(this._text, this.style);
        this.textMessage.x = this.width / 2;
        this.textMessage.y = 10;
        this.textMessage.scale.set(0.5);
        this.textMessage.anchor.set(0.5, 0);
        this.addChild(this.textMessage);
    }
    get text() {
        return this_.text;
    }
    set text(value) {
        this._text = value;
    }
}